"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeExplanationGetter = exports.makeExplanation = exports.ValidationError = exports.setErrorHook = void 0;
const awesome_ajv_errors_1 = require("awesome-ajv-errors");
let errorHook = undefined;
function setErrorHook(fn) {
    errorHook = fn;
}
exports.setErrorHook = setErrorHook;
class ValidationError extends Error {
    constructor(errors, schema, data) {
        super('Validation failed');
        this.errors = errors;
        makeExplanationGetter(this, 'explanation', errors, schema, data);
        errorHook === null || errorHook === void 0 ? void 0 : errorHook(this);
    }
}
exports.ValidationError = ValidationError;
function makeExplanation(errors, schema, data, noFallback = false) {
    if (schema && typeof schema === 'object')
        return awesome_ajv_errors_1.prettify({
            errors,
            schema,
            data
        });
    else if (!noFallback)
        return JSON.stringify(errors, null, 2);
    else
        return undefined;
}
exports.makeExplanation = makeExplanation;
function makeExplanationGetter(target, property, errors, schema, data, noFallback = false) {
    let cache = undefined;
    Object.defineProperty(target, property, {
        get() {
            if (cache !== undefined)
                return cache;
            cache = makeExplanation(errors, schema, data, noFallback);
            return cache;
        }
    });
    return target;
}
exports.makeExplanationGetter = makeExplanationGetter;
